<template>
  <!-- <div class="productPage"> -->
    <div class="product" v-if="xgcp.list&&xgcp.list.length">
      <h3>{{detail.name}}</h3>
      <div ref="contentWidth">
        <div class="scroll-content" ref="scrollContent1">
          <div class="scroll-slide" v-for="(item,index) in detail.list" :key="index" @click="updateItem(item)">
            <div class="bsImg1">
              <img :src="item.img_url" alt="" />
            </div>
            <p>{{item.proname_en}}</p>
          </div>
          <div v-show="hide" class="scroll-slide" v-for="(item1,index) in detail.list" :key="detail.list.length+index" @click="updateItem(item1)">
            <div  class="bsImg1">
              <img :src="item1.img_url" alt="" />
            </div>
            <p>{{item1.proname_en}}</p>
          </div>
        </div>
      </div>
      <span v-if="hide" class="scroll-button scroll-button-prev" @click="prev"><img :src="hrefurl+'/public/exhibit/pageLeft.png'" alt="" srcset=""/></span>
      <span v-if="hide" class="scroll-button scroll-button-next" @click="next"><img :src="hrefurl+'/public/exhibit/pageLeft.png'" alt="" srcset=""/></span>
    </div>
  <!-- </div> -->
</template>

<script>
export default {
  props:{
    xgcp:Object
  },
  data(){
    return{
      num:0,
      detail:{},
      hide:true
    }
  },
  mounted(){
    if (this.xgcp.list&&this.xgcp.list.length) {
      this.$refs.scrollContent1.style.width = this.width+"px"
      this.hide=this.$refs.contentWidth.offsetWidth>this.xgcp.list.length*178?false:true
    }
  },
  methods:{
    prev(){
      if(this.num>=0){
        this.num=-this.width/2
        this.$refs.scrollContent1.style.transform="translateX("+this.num+"px)"
        this.$refs.scrollContent1.style.transition="all 0s"
      }
      setTimeout(()=>{
        this.betterScroll(178)
      },30)
    },
    next(){
      if(Math.abs(this.num)>=this.width-1056){
        this.num=1056-this.width/2
        this.$refs.scrollContent1.style.transform="translateX("+this.num+"px)"
        this.$refs.scrollContent1.style.transition="all 0s"
      }
      setTimeout(()=>{
        this.betterScroll(-178)
      },30)
    },
    betterScroll(amount){
      this.num=amount+this.num
      this.$refs.scrollContent1.style.transform="translateX("+this.num+"px)"
      this.$refs.scrollContent1.style.transition="all .5s"
    },
    updateItem(item){
      console.log(item);
      this.$router.push('/exhibit/details/'+item.id+'/'+item.ocid)
      this.$emit("update",item)
    }
  },
  watch:{
    xgcp(){
      this.width = this.xgcp.list.length*178*2
      this.detail = this.xgcp
      this.$nextTick(()=>{
        this.hide=this.$refs.contentWidth.offsetWidth>this.xgcp.list.length*178?false:true
      })
    }
  }

}
</script>

<style  scoped>
  .product{
    width: 100%;
    position: relative;
    padding-bottom: 30px;
  }
  .product h3{
    font-size: 20px;
    line-height: 60px;
    font-weight: 600;
    color: #008baf;
    text-align: center;
    font-family: 'FjallaOne-Regular';
  }
  .product>div{
    margin: 0 72px;
    width: calc(100% - 144px);
    overflow: hidden;
  }
  .scroll-content{
    display: flex;
  }
  .scroll-slide{
    display: inline-block;
    text-align: center;
    margin-right: 15px;
    width: 163px;
    cursor: pointer;
  }
  .bsImg1{
    width: 163px;
    height: 163px;
    background-color: white;
  }
  .bsImg1>img{
    /* object-fit: cover; */
  }
  .scroll-slide p{
    width: 100%;
    background-color: #008baf;
    /* line-height: 30px; */
    font-size: 14px;
    color: white;
    padding: 8px 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .scroll-button{
    position: absolute;
    top: 60px;
    width: 72px;
    cursor: pointer;
  }
  .scroll-button-prev{
    left: 0;
  }
  .scroll-button-next{
    transform: rotateY(180deg);
    right: 0;
  }
</style>